import script from "./NoticiaCriarEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiaCriarEditar.vue?vue&type=script&setup=true&lang=js"

import "./NoticiaCriarEditar.vue?vue&type=style&index=0&id=5e042deb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e042deb"]])

export default __exports__